const Icon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill="#575BFD" fillOpacity="0.12" />
    <g clipPath="url(#clip0_703_1441)">
      <path
        d="M20 30C14.5 30 10 25.5 10 20C10 14.5 14.5 10 20 10C25.5 10 30 14.5 30 20C30 25.5 25.5 30 20 30ZM20 12C15.6 12 12 15.6 12 20C12 24.4 15.6 28 20 28C24.4 28 28 24.4 28 20C28 15.6 24.4 12 20 12Z"
        fill="#575BFD"
      />
      <path
        d="M23 25.0998L19 20.3998V14.7998H21V19.5998L24.6 23.7998L23 25.0998Z"
        fill="#575BFD"
      />
    </g>
    <defs>
      <clipPath id="clip0_703_1441">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Icon;
